<template>
  <MeetingModule>
    <c-field
      v-model="model.mentor_classes"
      :rules="[required, min(1)]"
      :lazy-rules="true"
      hide-bottom-space
    >
      <div class="tw-grid tw-grid-cols-12 tw-gap-2">
        <div class="tw-col-span-full">
          <c-checkbox
            :model-value="allClassesSelected"
            :label="toggleLabel"
            :disable="!isEditable"
            @click="isEditable && toggleSelectAll()"
          />
        </div>

        <div
          class="tw-col-span-6 md:tw-col-span-3 lg:tw-col-span-2"
          v-for="mentorClass in mentorClasses"
          :key="mentorClass"
        >
          <c-checkbox
            :val="mentorClass"
            name="mentor_classes"
            v-model="model.mentor_classes"
            :label="mentorClass"
            :disable="!isEditable"
            @update:model-value="modelUpdate"
          />
        </div>
      </div>
    </c-field>
  </MeetingModule>
</template>

<script setup>
import axios from "axios";
import { onMounted, ref, computed, watchEffect } from "vue";
import MeetingModule from "components/meeting/modules/MeetingModule.vue";
import useHelpers from "composables/useHelpers";
import { required, min } from "common/validationRules.js";
import { useMeetingStore } from "store/modules/meetingStore";
import { storeToRefs } from "pinia";

// Define the model
const model = defineModel({
  required: true,
  type: Object,
});
const isStepCompleted = defineModel("isStepCompleted");

// Meeting store
const meetingStore = useMeetingStore();
const { isEditable: useIsEditable } = storeToRefs(meetingStore);

// On model update
const modelUpdate = (value) => {
  isStepCompleted.value = value && value.length > 0;
};

const isEditable = computed(() => {
  if (
    !model.value?.meeting_type ||
    model.value.meeting_type !== "group_meeting"
  ) {
    return useIsEditable.value;
  }

  if (!model.value?.status || model.value?.status === "concept") {
    return true;
  }

  return false;
});

// Helpers
const { schoolId } = useHelpers();

// Refs
const mentorClasses = ref([]);

// TODO: To store
const getMentorClasses = async () => {
  try {
    const { data } = await axios.get(`api/school/${schoolId}/mentor-classes`);

    mentorClasses.value = Object.values(data);
  } catch (error) {
    console.log("🚀 ~ getMentorClasses ~ error:", error);
  }
};

// Return boolean if all classes are selected
const allClassesSelected = computed(() => {
  if (model.value.mentor_classes) {
    return model.value.mentor_classes.length === mentorClasses.value.length;
  }
});

const toggleLabel = computed(() => {
  return allClassesSelected.value
    ? "Alle klassen deselecteren"
    : "Alle klassen selecteren";
});

const toggleSelectAll = () => {
  if (allClassesSelected.value) {
    model.value.mentor_classes = [];
  } else {
    model.value.mentor_classes = mentorClasses.value.map((item) => item);
  }
};

onMounted(async () => {
  await getMentorClasses();

  modelUpdate(model.value.mentor_classes);
});

watchEffect(() => {
  modelUpdate(model.value.mentor_classes);
});
</script>
